export const ru = {
  code: 'ru',
  logo: ['ЛИН', 'И', 'Я'] as [string, string, string],
  nav: { draw: 'Рисовать', journal: 'Журнал', dialogs: 'Диалоги' },
  step: {
    home: '',
    pre: 'чек-ин',
    draw: 'рисунок',
    load: '',
    analysis: 'разбор',
    exercise: 'практика',
    result: 'итог',
    fresult: 'итог',
    journal: 'журнал',
    dialogs: 'диалоги',
    room: 'диалог',
    replyq: 'твой ход',
  },
  pacer: { in: 'вдох…', out: 'выдох — веди' },

  home: {
    title: 'Что рисуем?',
    freeTitle: 'Свободный рисунок',
    freeDesc: 'Рисуй что хочется — ИИ посмотрит и откликнется. Можно поиграть вместе с друзьями.',
    therapyTitle: 'Арт-терапия',
    therapyDesc: 'Чек-ин → рисунок состояния → разбор → практика скругления и цвета → до/после.',
    footer: 'Практика рефлексии, не медицинская диагностика.',
  },
  streak: {
    first: 'Первая запись начнёт твою серию дней.',
    active: (n: number, total: number) =>
      `Серия: <b>${n} ${n === 1 ? 'день' : n < 5 ? 'дня' : 'дней'} подряд</b> · записей в журнале: ${total}`,
    broken: (total: number) => `Записей в журнале: ${total}. Нарисуй сегодня — серия продолжится.`,
  },

  checkin: {
    title: 'Как ты сейчас?',
    moodLow: 'тяжело',
    moodName: 'Состояние',
    moodHigh: 'прекрасно',
    energyLow: 'нет сил',
    energyName: 'Энергия',
    energyHigh: 'через край',
    tagsHint: 'Отметь, что откликается (необязательно):',
    feelHint: 'Как ты себя ощущаешь?',
    feelPlaceholder: 'Своими словами — или пропусти…',
    next: 'Дальше',
    tags: ['спокойно', 'тревожно', 'устал', 'злюсь', 'вдохновлён', 'пусто', 'радостно', 'напряжён'],
  },

  draw: {
    free: [
      'Свободный рисунок',
      'Рисуй что хочется. Уметь не нужно — чем свободнее, тем честнее.',
      'Когда почувствуешь «хватит» — жми готово. Можно и фото рисунка с бумаги.',
    ] as [string, string, string],
    therapy: [
      'Нарисуй, что внутри',
      'Абстрактно, пальцем. Чем «хуже», тем честнее.',
      'Линии, пятна, каракули. Или загрузи фото рисунка на бумаге — кнопка «Фото».',
    ] as [string, string, string],
    reply: [
      'Рисунок в диалог',
      'Твой ход — тоже линия. Нарисуй, что откликается.',
      'Дальше можно прикрепить вопрос — пусть угадывают тебя.',
    ] as [string, string, string],
    doneTherapy: 'Готово — разбери',
    doneReply: 'Дальше',
    doneFree: 'Готово — покажи ИИ',
    photo: 'Фото',
    clear: 'Очистить',
  },

  load: {
    default: 'Читаю линии…',
    free: ['ИИ смотрит на рисунок…', 'Читает углы и паузы…', 'Пишет отклик…'],
    compare: 'ИИ сравнивает до и после…',
  },

  analysis: {
    title: 'Что видно в рисунке',
    readCard: 'Разбор',
    questionsCard: 'Вопросы к себе',
    toPractice: 'Изменить это → практика',
    mSharp: 'острых поворотов',
    mCV: 'рваность темпа',
    mStrokes: 'штрихов',
    mSec: 'рисования',
    photoMode: 'фото-режим',
    photoModeNote: 'моторика появится в практике — там рисуешь в приложении',
  },

  exercise: {
    title: 'Практика',
    steps: [
      {
        tag: 'СКРУГЛЕНИЕ',
        text: 'На каждом выдохе — одна медленная дуга поверх острого угла. Круг в шапке задаёт ритм, линия сама скажет, попал ли.',
      },
      {
        tag: 'ЦВЕТ',
        text: 'Цвет состояния, к которому хочешь прийти. Медленные широкие мазки, как кистью, — на выдохе.',
      },
    ],
    focusPrefix: 'Фокус: ',
    next: 'Дальше',
    finish: 'Завершить практику',
    done: 'Готово',
    hintArc: 'линия покажет, попал ли в ритм',
    hintColor: 'веди медленно, как кистью',
    fbLonger: 'чуть длиннее — спокойной дугой',
    fbSlower: 'медленнее',
    fbSmoother: 'плавнее, без углов',
    fbInRhythm: 'да — в ритме',
    fbGoodNext: 'хорошо. следующую — на выдохе',
    fbBrushSlower: 'медленнее, как кистью',
    fbBrushCalmer: 'ещё спокойнее',
    fbColorOk: 'так. цвет ложится',
    fbUndone: 'убрал последний штрих',
    freeTag: 'ДОРИСОВКА',
    freeText: 'Добавь то, чего не хватает — любой инструмент, цвет и толщина. Пейсер в шапке, если хочется ритма.',
    freeCounted: 'свободный режим — всё засчитывается',
    freeAdded: 'добавлено',
  },

  result: {
    title: 'До / После',
    before: 'до',
    after: 'после',
    finalCard: 'Взгляд на «после»',
    statePrefix: 'Состояние: ',
    postCard: 'Пост к записи',
    postPlaceholder: 'Пара слов об этой сессии — попадёт в журнал…',
    savePost: 'Сохранить пост',
    postSaved: 'Сохранено в журнал ✓',
    askCard: 'Спросить ИИ',
    askPlaceholder: 'Про рисунок, состояние, практику…',
    aiWriting: 'ИИ пишет',
    aiFailed: 'Не получилось — попробуй ещё раз.',
    drawOver: 'Дорисовать',
    newSession: 'Новая сессия',
    stats: 'Метрики сессии',
    deltaSharp: 'острых поворотов после практики',
    deltaArcs: 'дуг и мазков в ритме',
    dlCheckin: 'Чек-ин на входе',
    dlCheckinVal: (m: number | null, e: number | null) => `состояние ${m}/9 · энергия ${e}/9`,
    dlSharp: 'Острые повороты',
    dlCV: 'Рваность темпа',
    dlArcs: 'Дуг и мазков в ритме',
  },

  fresult: {
    title: 'Готово',
    responseCard: 'Отклик ИИ',
    postPlaceholder: 'Подпись к рисунку — попадёт в журнал…',
    continue: 'Продолжить рисунок',
    newDrawing: 'Новый рисунок',
  },

  journal: {
    title: 'Журнал',
    lead: 'Лента твоих рисунков и состояний.',
    empty: 'Пока пусто — нарисуй первый рисунок.',
    kindTherapy: 'арт-терапия',
    kindFree: 'свободный рисунок',
  },

  dialogs: {
    title: 'Диалоги',
    lead: 'Комната для двоих или для компании: рисунки, вопросы, догадки — без конца.',
    empty: 'Диалогов пока нет — нарисуй что-нибудь и отправь другу вопросом.',
    you: 'Ты',
    friend: 'Друг',
    ai: 'ИИ',
    titleWith: (name: string) => `Я и ${name}`,
    titleDefault: 'Диалог',
    titleGroup: 'Компания',
    unread: (n: number) => `${n} нов.`,
    streak: (n: number) => `серия ${n} ${n === 1 ? 'день' : n < 5 ? 'дня' : 'дней'}`,
    participants: (n: number) => `${n} ${n === 1 ? 'участник' : n < 5 ? 'участника' : 'участников'}`,
    locked: 'вход закрыт',
    opened: 'вход открыт',
    lock: 'Закрыть вход',
    unlock: 'Открыть вход',
    kindDuo: 'Одному человеку',
    kindDuoHint: 'вход закроется, когда второй войдёт',
    kindGroup: 'Компании',
    kindGroupHint: 'до 12 человек, вход по ссылке открыт',
    rename: 'Переименовать',
    renameTitle: 'Как назвать этот диалог?',
    personalLabel: 'Для меня',
    personalPlaceholder: 'Я и Таня',
    personalHint: 'видишь только ты',
    sharedLabel: 'Для всех',
    sharedPlaceholder: 'Наша семья',
    sharedHint: 'видят все участники и превью ссылки',
    myNameLabel: 'Моё имя в диалоге',
    save: 'Сохранить',
    cancel: 'Отмена',
    nameTitle: 'Как тебя подписать?',
    nameHint: 'Имя увидят участники диалога. Можно просто «мама» или «С.»',
    namePlaceholder: 'Имя',
    nameGo: 'Войти в диалог',
    composerText: 'Написать…',
    composerDraw: 'Рисунок',
    guess: 'Ответить',
    guessPlaceholder: 'Твоя догадка…',
    replyTo: 'Ответ на',
    questionOn: 'Вопрос к рисунку',
    yourMove: 'Твой ход отправлен',
    shareMove: 'Отправить ход в WhatsApp',
    shareLink: 'Поделиться ссылкой',
    copyLink: 'Скопировать ссылку',
    copied: 'Ссылка скопирована ✓',
    shareQuestion: (who: string, q: string, url: string) => `${who ? who + ': ' : ''}${q} → ${url}`,
    shareAnswered: (url: string) => `Мой ответ уже там — теперь твой ход → ${url}`,
    shareDrawing: (url: string) => `Нарисовал(а) для тебя — посмотри и ответь рисунком → ${url}`,
    sys: {
      joined: (n: string) => `${n || 'Кто-то'} теперь в диалоге`,
      renamed: (n: string, t: string) => (t ? `${n || 'Кто-то'} назвал(а) диалог «${t}»` : `${n || 'Кто-то'} убрал(а) общее имя`),
      locked: (n: string) => `${n || 'Кто-то'} закрыл(а) вход`,
      unlocked: (n: string) => `${n || 'Кто-то'} открыл(а) вход`,
    },
    lockedPage: 'Вход в этот диалог закрыт — его участники решили остаться вдвоём.',
    fullPage: 'В этом диалоге уже нет мест.',
    notFound: 'Диалог не найден — возможно, ссылка устарела.',
    goHome: 'Нарисовать своё',
    loadMore: 'Показать раньше',
    preview: 'Ты смотришь диалог как гость. Чтобы ответить — назови себя.',
    joinCta: 'Войти и ответить',
    truthLabel: 'Что загадано',
    truthHint: 'увидит только ИИ, когда будет судить догадки',
    truthPlaceholder: 'например: тревога',
  },

  replyq: {
    title: 'Твой ход',
    lead: 'Прикрепи вопрос к рисунку — пусть угадывают тебя. Или отправь просто так.',
    send: 'Отправить в диалог',
    noQuestion: 'Без вопроса',
    customPlaceholder: 'Свой вопрос…',
  },

  share: {
    card: 'Отправить другу вопросом',
    presets: ['Угадай, что нарисовано', 'Угадай, какое у меня сейчас состояние'],
    custom: 'Свой вопрос',
    forWhom: 'Кому',
    create: 'Создать диалог и ссылку',
    open: 'Открыть диалог →',
    shareCard: 'Поделиться карточкой',
    cardHash: '#33unicorns · liniya.org',
    cardBefore: 'до',
    cardAfter: 'после',
    ogSubtitle: 'ответь одним словом — и нарисуй своё',
  },

  support: {
    title: 'Если сейчас тяжело',
    text: 'ЛИНИЯ — практика рефлексии, а не помощь в кризисе. Если состояние не отпускает или становится опасным — поговори с живым человеком: близким, врачом или службой поддержки в твоей стране. Это нормальный шаг, и он работает быстрее рисунка.',
  },

  errors: {
    offline: 'Нет связи с сервером — ИИ временно недоступен. Показываю локальный отклик, рисунок и метрики сохранены.',
    aiFallback: 'ИИ не ответил — это локальный отклик по метрикам.',
    threadFailed: 'Не удалось отправить. Проверь связь и попробуй ещё раз.',
  },
}

export type Dict = typeof ru
